import { createSelector } from "reselect";

import type { Project } from "@packages/client";
import type { RootState } from "Store/configureStore";

const selectDomain = ({ projectDomain }: RootState) => projectDomain;

const encodeDomainId = (id: string) => {
  return id.replace(/\./g, "");
};

// Project's Domains
export const domainsSelector = createSelector(
  selectDomain,
  (_: RootState, params: { projectId: string }) => params,
  (projectDomain, { projectId }) => projectDomain[projectId]?.data ?? []
);

export const domainsLoadingSelector = createSelector(
  selectDomain,
  (_: RootState, params: { projectId: string }) => params,
  (projectDomain, { projectId }) => projectDomain[projectId]?.loading
);

export const domainsErrorSelector = createSelector(
  selectDomain,
  (_: RootState, params: { projectId: string }) => params,
  (projectDomain, { projectId }) => projectDomain[projectId]?.errors
);

export const domainsStatusSelector = createSelector(
  selectDomain,
  (_: RootState, params: { projectId: string }) => params,
  (projectDomain, { projectId }) => projectDomain[projectId]?.status
);

// Domain
export const domainSelector = createSelector(
  selectDomain,
  (_: RootState, params: { domainId: string; projectId: string }) => params,
  (projectDomain, { domainId, projectId }) =>
    projectDomain[projectId]?.data?.find(
      elt => domainId === encodeDomainId(elt.id)
    )
);

export const domainLoadingSelector = createSelector(
  selectDomain,
  (_: RootState, params: { domainId: string; projectId: string }) => params,
  (projectDomain, { projectId }) => projectDomain[projectId].loading
);

export const domainStatusSelector = createSelector(
  selectDomain,
  (_: RootState, params: { domainId: string; projectId: string }) => params,
  (projectDomain, { domainId, projectId }) =>
    projectDomain[projectId]?.[domainId]?.status
);

export const domainErrorSelector = createSelector(
  selectDomain,
  (_: RootState, params: { domainId: string; projectId: string }) => params,
  (projectDomain, { domainId, projectId }) =>
    projectDomain[projectId]?.[domainId]?.errors
);

export const domainPermissionSelector = createSelector(
  selectDomain,
  (_: RootState, params: { project?: Project }) => params,
  (projectDomain, { project }) => project?.hasPermission?.("#manage-domains")
);
